// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
import { propType } from 'graphql-anywhere';
// ANTD
import Spin from 'antd/lib/spin';
import Modal from 'antd/lib/modal';
// APOLLO
import { graphql } from 'react-apollo';
import sessionFragment from 'ApolloClient/Fragments/sessionFragment';
import SESSIONS_BY_CLIENT_ID from 'ApolloClient/Queries/sessionsByClientId';
import SectionHeader from 'components/text/SectionHeader';
import SectionRow from 'components/common/SectionRow';
// COMPONENTS
import SessionsTable from 'components/common/SessionsTable';
import SaveCalendarSession from 'components/common/SaveCalendarSession';

export class ClientSessions extends React.PureComponent {
  state = {
    saveModalIsVisible: false,
    editSession: null,
  };

  toggleSave = () => {
    this.setState({ saveModalIsVisible: !this.state.saveModalIsVisible });
  };

  handleEdit = session => {
    this.setState({ editSession: session });
    this.toggleSave();
  };

  render() {
    const {  data, windowWidth } = this.props;
    const { error, loading, sessionsByClientId } = data;
    const { saveModalIsVisible, editSession } = this.state;
    const showCols = windowWidth > 789
      ? ['title', 'description', 'category', 'date', 'edit', 'delete'] // mobile
      : ['title','category', 'date', 'edit']; // desktop

    if (error) {
      console.log(error);
      return <span>Something went wrong :(</span>;
    }

    if (loading) {
      return (
        <div
          className="flex justify-center align-middle"
          style={{
            width: 900,
            maxWidth: '100%',
            margin: 'auto',
            height: 400,
          }}
        >
          <Spin />
        </div>
      );
    }

    return (
      <SectionRow>
        <SectionHeader>SESSIONS</SectionHeader>
        {/* <SessionFormModal
          clientId={clientId}
          sessionTypes={this.props.userData.user.organization.sessionTypes}
          {...this.props}
        />
         */}
        <SessionsTable
          showCols={showCols}
          sessions={sessionsByClientId}
          onEdit={this.handleEdit}
          pagination={{ defaultPageSize: 5 }}
        />

        {/* Force re-render to clear form fields */}

        {saveModalIsVisible && (
          <Modal visible={saveModalIsVisible} footer={null} title="EDIT SESSION" onCancel={this.toggleSave}>
            <div className="flex justify-center align-center mx-auto">
              <SaveCalendarSession
                session={editSession}
                sessionTypes={this.props.currentUser.organization.sessionTypes}
                onCancel={this.toggleSave}
                onComplete={this.toggleSave}
                hideClientInput
              />
            </div>
          </Modal>
        )}
      </SectionRow>
    );
  }
}

ClientSessions.propTypes = {
  data: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool,
    sessions: PropTypes.arrayOf(propType(sessionFragment)),
  }).isRequired,
  showCols: PropTypes.arrayOf(PropTypes.string),
  currentUser: PropTypes.object.isRequired, // eslint-disable-line
};

ClientSessions.defaultProps = {
  // showCols: ['title', 'description', 'category', 'date', 'client', 'edit', 'delete'],
};

const options = props => ({ variables: { _id: props.clientId } });

export default graphql(SESSIONS_BY_CLIENT_ID, { options })(ClientSessions);



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientSessions/index.js